module.exports = __webpack_public_path__ + "static/media/TJ.88ea306f.svg";